import { useMutation, useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import { updateMGA } from "../../../../../actions/Utilities/MGA";
import { toast } from "../../../../../components/toastNotification";
import { editStateMGA } from "../atoms/atoms";

const useUpdateMGA = () => {
  const queryClient = useQueryClient();
  const [, setEditState] = useRecoilState(editStateMGA);

  const { mutate } = useMutation((mga) => updateMGA({ ...mga }), {
    onSuccess: (res) => {
      if (res.data === "duplicate") {
        toast.fire(
          "Failed",
          "Another MGA already has the same information",
          "error"
        );
      } else if (res.status === 201) {
        setEditState(false);
        queryClient.invalidateQueries("GetMGAList");
        toast.fire("Success", "MGA updated successfully", "success");
      } else {
        toast.fire(
          "Failed",
          "Server Error: Cannot update MGA",
          "error"
        );
      }
    },
    onError: (error) => {
      if (
        error.response.data.message === "Failed sending of email" ||
        error.response.data.message === "Failed inserting of notification"
      ) {
        toast.fire(
          "Success",
          "MGA updated successfully, but " + error.response.data.message,
          "warning"
        );
        queryClient.invalidateQueries("GetMGAList");
      } else {
        toast.fire(
          "Failed",
          "Server Error: Cannot add new MGA",
          "error"
        );
      }
    },
  });
  return mutate;
};
export default useUpdateMGA;
